(function () {
  if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
  if (typeof Lenis === 'undefined') return;

  var lenis = new Lenis({
    autoRaf: true,
    lerp: 0.085,
    smoothWheel: true,
    syncTouch: false,
    wheelMultiplier: 0.95,
    touchMultiplier: 1.1,
    anchors: true,
    allowNestedScroll: true,
    autoToggle: true,
    prevent: function (node) {
      return Boolean(
        node.closest &&
          node.closest(
            'cart-drawer, .drawer, dialog, modal-dialog, product-modal, .product-media-modal, .predictive-search, [data-lenis-prevent]'
          )
      );
    },
  });

  window.nraLenis = lenis;
})();
